import { useStyles } from "./style"

export const VerticalDivider = () => {
    const classes = useStyles()

    return <div className={classes.root}>
        <div className={classes.inner_div} />
    </div>
}